<template>
  <main class="page content">
    <div v-if="page" :class="!loading ? '' : 'loading'">
      <hero :page="page" :colorScheme="'green'"></hero>
      <keep-in-touch></keep-in-touch>
      <shop-module></shop-module>
    </div>
  </main>
</template>

<script>
import Hero from '@/components/common/Hero'
import KeepInTouch from '@/components/participate/KeepInTouch'
import ShopModule from '@/components/common/ShopModule'

export default {
  name: 'participate',
  data () {
    return {
      loading: true,
      page: null
    }
  },
  mounted () {
    this.fetchPost()
  },
  methods: {
    fetchPost () {
      let vm = this
      // GET /posts => get_single_post() [theme-folder]/api/functions.php
      vm.$axios.get('/posts', {
        params: {
          slug: 'participate'
        }
      })
      .then((response) => {
        vm.page = response.data
        if (vm.$route.hash) vm.scrollToAnchor()
        process.nextTick(() => {
          vm.loading = false
        })
      })
      .catch((err) => {
        vm.loading = false
        console.log(err)
      })
    },
    scrollToAnchor () {
      let id = this.$route.hash.replace('#', '')
      process.nextTick(() => {
        document.getElementById(id).scrollIntoView()
      })
    }
  },
  components: {
    Hero,
    KeepInTouch,
    ShopModule
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Participate.vue?da227c44